import { forEach } from "lodash";
import { IPromise } from "angular";
import { ISettingsService, ILeaguesResource, ILimitByState } from "../../../typings/typings";
import { LegacyUrlService } from "../../LegacyUrl";

export class LeaguesResource implements ILeaguesResource {
    public static $inject = ["SettingsService", "$resource", "LegacyUrlService"];
    constructor(private SettingsService: ISettingsService, private $resource: any, private LegacyUrlService: LegacyUrlService) {}

    public getLeagues(
        types: string,
        states: string,
        skillLevel: string,
        limit: number,
        path: string,
        portals: string,
        tags: string,
        includeHidden: boolean,
        limitByState: ILimitByState
    ): Promise<Object> {
        // Append parameter
        if (typeof limitByState === "undefined") {
            limitByState = {
                inProgress: 0,
                finished: 0,
                upcoming: 0,
            };
        } else {
            if (typeof limitByState.inProgress === "undefined") {
                limitByState.inProgress = 0;
            }

            if (typeof limitByState.finished === "undefined") {
                limitByState.finished = 0;
            }

            if (typeof limitByState.upcoming === "undefined") {
                limitByState.upcoming = 0;
            }
        }

        let url =
            this.SettingsService.eslapi_host +
            "/leagues?types=:types&states=:states&skill_levels=:skillLevel&limit.total=:limit&path=:path&portals=:portals&tags=:tags&limit.state.inProgress=:limitInProgress&limit.state.finished=:limitFinished&limit.state.upcoming=:limitUpcoming";
        let leaguePromise = this.$resource(url).get(
            {
                types: types,
                states: states,
                skillLevel: skillLevel,
                limit: limit,
                path: path,
                portals: portals,
                tags: tags,
                includeHidden: includeHidden,
                limitInProgress: limitByState.inProgress,
                limitFinished: limitByState.finished,
                limitUpcoming: limitByState.upcoming,
            },
            (data, headers) => {
                forEach(data, (league, key) => {
                    if (league.hasOwnProperty("uri")) {
                        league.uri = this.LegacyUrlService.getPathFromLegacyPath(league.uri);
                    }
                });

                data.headers = headers;
            }
        );

        return leaguePromise.$promise;
    }

    public getLeagueById(id: number): IPromise<Object> {
        return this.$resource(this.SettingsService.eslapi_host + "/leagues/:leagueId").get({ leagueId: id }, function(data, headers) {
            data.headers = headers;
        }).$promise;
    }

    /**
     * Takes an Array of leagueIds and returns an Array of league resources
     * @param ids
     */
    public getLeaguesByIds(ids: number[]): Promise<Object> {
        return this.$resource(this.SettingsService.eslapi_host + "/leagues?league_ids=:leagueIds").get(
            { leagueIds: ids.join(",") },
            function(data, headers) {
                data.headers = headers;
            }
        ).$promise;
    }

    public getMatches(leagueId: number) {
        return this.$resource(this.SettingsService.eslapi_host + "/leagues/:leagueId/matches").query({ leagueId: leagueId }).$promise;
    }
}
